import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import portalSettingsManager from "utils/portalSettingsManager";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    color: "#FFFFFF",
    alignItems: "center",
  },
  title: {
    flexGrow: 1,
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  menuButton: {
    color: "inherit",
    textTransform: "none",
    [theme.breakpoints.down("md")]: {
      "& .MuiButton-endIcon": {
        marginLeft: 0,
      },
    },
  },
  menuButtonBox: {
    marginLeft: theme.spacing(4),
    display: "flex",
    [theme.breakpoints.down(700)]: { display: "none" },
  },
  hamburgerIconBox: {
    display: "none",
    [theme.breakpoints.down(700)]: { display: "flex" },
    "& button": {
      color: "white",
    },
    "& .MuiBadge-dot": {
      backgroundColor: "#eb004d",
    },
  },
  srOnly: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap",
  },
  hamburgerMenuWelcomeMessage: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  hamburgerMenuItemHeader: {
    fontWeight: "bold",
  },
  logoLink: {
    margin: "4px",
  },
  logoBox: {
    alignItems: "center",
    display: "flex",
    margin: portalSettingsManager?.header?.logo?.marginInPixel
      ? `${portalSettingsManager.header.logo.marginInPixel}`
      : portalSettingsManager?.header?.logo?.heightInPixel
        ? `${Number(portalSettingsManager.header.logo.heightInPixel) / 2}px`
        : `0 14px 0 14px`,
    [theme.breakpoints.down(700)]: { margin: 0 },
    [theme.breakpoints.down(500)]: {
      marginLeft: "-15px",
    },
  },
  welcomeText: {
    alignItems: "right",
    marginRight: theme.spacing(2),
    alignContent: "center",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      margin: "0",
      padding: "0px 5px 0px 30px",
      width: "20%",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  BlankBox: {
    marginLeft: "auto",
  },
}));
